module.exports = __webpack_public_path__ + "static/media/ie.3a4c4325.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ie.svg
// module id = 2114
// module chunks = 0